export const PRODUCT_VARIATIONS_LAYOUT_PROPERTY_NAME = "VirtoFrontend_UI_Layout";

export const PRODUCT_VARIATIONS_LAYOUT_PROPERTY_VALUES = {
  b2b: "B2B",
  b2c: "B2C",
};
